export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id="cdm-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="100%" stopColor="#14B8A6" />
      </linearGradient>
    </defs>
    <rect x="1" y="1" width="38" height="38" rx="11" fill="url(#cdm-g)" />
    <path
      d="M12 15.5h13.5M22 11.5l4 4-4 4"
      stroke="#04121B"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M28 25.5H14.5M18 21.5l-4 4 4 4"
      stroke="#04121B"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default function Logo({ onClick }) {
  return (
    <span
      onClick={onClick}
      data-testid="brand-logo"
      className="flex cursor-pointer select-none items-center gap-2.5"
    >
      <LogoMark className="h-9 w-9 drop-shadow-[0_0_14px_rgba(16,185,129,0.45)]" />
      <span className="font-display text-xl font-bold tracking-tight text-white">
        CDM<span className="text-emerald-400">&nbsp;Pay</span>
      </span>
    </span>
  );
}
